import { BorderRadiusTokens, ColorTokens, DropDownOrientation, FontFamilyTokens, FontSizeTokens, IconSizeTokens, IconTokens, } from '@voltmoney/schema';
import React, { memo, useEffect, useRef, useState, } from 'react';
import { ActivityIndicator, Modal, Platform, ScrollView, StyleSheet, TouchableOpacity, View, } from 'react-native';
import Icon from '../icon/Icon';
import Typography from '../typography/Typography';
import ThemeProvider from '@voltmoney/theme';
import { isFromTDLPlatform } from '../pages/utils';
const DropdownInput = ({ shouldShowTitle, onValueSelect, height, showEditable, label, data, action, width, triggerAction, openAction, closeAction, value, onOpenDropDown, dropDownOrientation = DropDownOrientation.BOTTOM, }) => {
    const DropdownButton = useRef(undefined);
    const [visible, setVisible] = useState(false);
    const [isLoading, setLoading] = useState(false);
    const [selected, setSelected] = useState(undefined);
    const [dropdownTop, setDropdownTop] = useState(0);
    const [dropdownBottom, setDropdownBottom] = useState(0);
    const [dropdownLeft, setDropdownLeft] = useState(0);
    const [dropdownWith, setDropdownWidth] = useState(0);
    const theme = ThemeProvider.getTheme();
    const colorMapping = theme.colors;
    const fontFamilyMapping = theme.fontFamily;
    const fontSizeMapping = theme.fontSize;
    const borderRadiusMapping = theme.borderRadius;
    const isfromTDL = isFromTDLPlatform();
    useEffect(() => {
        if (visible === true) {
            triggerAction &&
                openAction &&
                triggerAction(openAction);
        }
        if (visible === false) {
            triggerAction &&
                closeAction &&
                triggerAction(closeAction);
        }
    }, [visible]);
    const setSelectedValue = (value) => {
        const selectedItem = data.find((item, index, array) => {
            if (item.value === value) {
                setSelected(item);
                return true;
            }
            return false;
        });
    };
    useEffect(() => {
        setSelectedValue(value);
    }, [value]);
    const styles = StyleSheet.create({
        inputContainer: {
            flexDirection: 'row',
            justifyContent: 'space-between',
            alignItems: 'center',
            backgroundColor: colorMapping[ColorTokens.White],
            borderRadius: isfromTDL ? borderRadiusMapping[BorderRadiusTokens.BR2] : borderRadiusMapping[BorderRadiusTokens.BR1],
            borderColor: visible ? colorMapping[ColorTokens.Primary_100] : colorMapping[ColorTokens.Grey_Smoke],
            borderWidth: 1,
            paddingVertical: 12,
            paddingHorizontal: 16,
            width: width ? width : '100%'
        },
        buttonTextUnselected: {
            fontFamily: fontFamilyMapping[FontFamilyTokens.Inter],
            color: colorMapping[ColorTokens.Grey_Smoke],
            lineHeight: 24,
            fontSize: fontSizeMapping[FontSizeTokens.MD],
            fontWeight: '400',
        },
        buttonTextSelected: {
            fontFamily: fontFamilyMapping[FontFamilyTokens.Inter],
            color: colorMapping[ColorTokens.Grey_Night],
            lineHeight: 24,
            fontSize: fontSizeMapping[FontSizeTokens.XL],
            fontWeight: '400',
        },
        icon: {
            marginRight: 10,
        },
        dropdown: {
            backgroundColor: colorMapping[ColorTokens.White],
            zIndex: 99,
            shadowColor: '#000000',
            shadowOffset: { width: 0, height: 4 },
            shadowOpacity: 0.14,
            shadowRadius: 8,
            borderColor: colorMapping[ColorTokens.Grey_Chalk],
            borderWidth: 1,
            borderRadius: 8,
        },
        overlay: {
            width: '100%',
            height: '200%',
        },
        item: {
            paddingHorizontal: 16,
            paddingVertical: 12,
            borderBottomWidth: 1,
            borderBottomColor: colorMapping[ColorTokens.Grey_Milk],
            flexDirection: 'row',
            justifyContent: 'space-between',
            alignItems: 'center',
        },
        iconContainer: {
            position: 'relative',
            top: 5,
        },
    });
    const toggleDropdown = () => {
        visible ? setVisible(false) : openDropdown();
    };
    const openDropdown = () => {
        onOpenDropDown && onOpenDropDown();
        setTimeout(() => {
            DropdownButton.current.measure((_fx, _fy, _w, h, _px, py) => {
                setDropdownBottom(-(py - height - 5));
                setDropdownTop(py + h + 5);
                setDropdownLeft(_px);
                setDropdownWidth(_w - 5);
            });
            setVisible(true);
        }, 400);
    };
    const onItemPress = async (item) => {
        onValueSelect &&
            onValueSelect(item.value);
        setSelected(item);
        if (action && triggerAction) {
            setLoading(true);
            await triggerAction({
                ...action,
                payload: {
                    ...action.payload,
                    value: item.value,
                },
            });
            setLoading(false);
        }
        setVisible(false);
    };
    const renderItem = (item) => (React.createElement(TouchableOpacity, { style: styles.item, onPress: () => onItemPress(item) },
        React.createElement(Typography, { label: item.label, color: ColorTokens.Grey_Charcoal, fontSize: FontSizeTokens.SM, fontWeight: '500', fontFamily: FontFamilyTokens.Inter, lineHeight: 20 }),
        isLoading &&
            item.value === selected.value && (React.createElement(ActivityIndicator, { color: theme.colors[ColorTokens.Primary_100], size: 24 }))));
    const renderDropdown = () => {
        return (React.createElement(Modal, { visible: visible, transparent: true },
            React.createElement(TouchableOpacity, { style: styles.overlay, onPress: () => setVisible(false) },
                React.createElement(View, { style: [
                        styles.dropdown,
                        dropDownOrientation === DropDownOrientation.BOTTOM && { top: dropdownTop },
                        dropDownOrientation === DropDownOrientation.TOP && { bottom: dropdownBottom },
                        { left: dropdownLeft },
                        { width: dropdownWith },
                    ] },
                    React.createElement(View, { style: {
                            maxHeight: 180,
                            height: Platform.OS !== 'web' && data?.length > 4 ? 180 : data?.length * 45
                        } },
                        React.createElement(ScrollView, { showsVerticalScrollIndicator: true, nestedScrollEnabled: true, persistentScrollbar: data?.length > 4 },
                            React.createElement(View, null, data.map((person, index) => {
                                return (React.createElement(View, { key: index }, renderItem(person)));
                            }))))))));
    };
    const renderTitle = () => {
        return (React.createElement(View, { style: {
                position: 'absolute',
                left: 12,
                top: -8,
                backgroundColor: 'white',
                paddingHorizontal: 4,
            } },
            React.createElement(Typography, { label: label, fontSize: FontSizeTokens.XS, color: showEditable ? ColorTokens.Grey_Night : ColorTokens.Grey_Charcoal, fontWeight: '400' })));
    };
    return (React.createElement(TouchableOpacity, { ref: DropdownButton, style: [styles.inputContainer, width && { width: width }], onPress: toggleDropdown },
        selected && shouldShowTitle && renderTitle(),
        React.createElement(Typography, { label: (!!selected && selected.label) || label, fontSize: FontSizeTokens.MD, color: !!selected && selected.label
                ? ColorTokens.Grey_Night
                : showEditable ? ColorTokens.Grey_Night : ColorTokens.Grey_Smoke, lineHeight: 24, fontWeight: '400', fontFamily: FontFamilyTokens.Inter }),
        visible && renderDropdown(),
        React.createElement(View, { style: styles.iconContainer },
            React.createElement(Icon, { name: IconTokens.ChevronDown, size: IconSizeTokens.XXL }))));
};
export default memo(DropdownInput);
export { DropdownInput };
